<section class="modal-dialog modal-content overlay-def">
  <header class="modal-header">
    <h2 class="modal-title" id="lbx-title">{{'modal_timeout.title' | translate }}</h2>
  </header>
  <div class="modal-body">
    <div *ngIf="!data.isSessionExpired">
      <p>
        {{ 'modal_timeout.expire_in' | translate }}
        {{data.minutesRemaining}}&nbsp;{{ 'modal_timeout.min' | translate }}
        {{data.secondsRemaining}}&nbsp;{{ 'modal_timeout.sec' | translate }}.
      </p>
      <p>{{ 'modal_timeout.expiration_alert' | translate }}</p>
    </div>
    <div *ngIf="data.isSessionExpired">
      <p>{{ 'modal_timeout.already_expired' | translate }}</p>
    </div>
  </div>
  <div class="modal-footer">
    <ng-container *ngIf="!data.isSessionExpired">
      <div class="row">
        <div class="col-sm-12 col-md-offset-3 col-md-4 mrgn-tp-md">
          <carm-button id="continueBtn" btnLabel="{{'modal_timeout.btn_extend_session' | translate}}" [btnStretch]="true"
            [btnTypePrimary]="true" (click)="closeModal(sessionTimeOutBtn.extendSession)">
          </carm-button>
        </div>
        <div class="col-sm-12 col-md-4 mrgn-tp-md">
          <carm-button id="exitsessionBtn" btnLabel="{{'modal_timeout.btn_leave_app' | translate}}" [btnStretch]="true" [btnTypePrimary]="true"
            (click)="closeModal(sessionTimeOutBtn.exitSession)">
          </carm-button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="data.isSessionExpired">
      <div class="row no-margin">
        <div class="col-sm-12 col-md-offset-8 col-md-4 mrgn-tp-md">
          <carm-button id="startagainBtn" btnLabel="{{'modal_timeout.btn_start_again' | translate}}" [btnStretch]="true" [btnTypePrimary]="true"
            (click)="closeModal(sessionTimeOutBtn.pastTimeout)">
          </carm-button>
        </div>
      </div>
    </ng-container>
  </div>
</section>
